import dayjs, { Dayjs } from "dayjs";
import { FilterValue } from "../../Filters/FilterValue";
import { SortType } from "../../SortType";
import { InventoryTypeOptions } from "../../inventory/InventoryListing";

export interface LogisticsAnalyticsFilters {
  page: number;
  limit: number;
  inventory_type: FilterValue | null | undefined;
  order_id: FilterValue[];
  order_type: FilterValue[] | null;
  customer_id: FilterValue[];
  start_date: Dayjs;
  end_date: Dayjs;
  sortBy: string;
  sortType: SortType;
  pm_adminids: FilterValue[];
}

export interface LogisticsAnalyticsSelectedFilters {
  page: number;
  limit: number;
  inventory_type: FilterValue | null | undefined;
  order_id: FilterValue[];
  order_type: FilterValue[] | null;
  customer_id: FilterValue[];
  start_date: string;
  end_date: string;
  sortBy: string;
  sortType: SortType;
  pm_adminids: FilterValue[];
}

export interface LogisticsAnalyticsAPIFilters {
  pm_adminids: FilterValue[] | null;
  order_id: FilterValue[] | null;
  order_type: FilterValue[] | null;
  customer_id: FilterValue[] | null;
  inventory_type: FilterValue | null | undefined;
  start_date: string;
  end_date: string;
  page?: number;
  limit?: number;
  sortBy?: string;
  sortType?: "ASC" | "DESC";
}

export function parseQueryParamsForLogisticsAnalyticsFilters(
  params: LogisticsAnalyticsFilters | null,
  query_params: URLSearchParams
): LogisticsAnalyticsFilters {
  const currentDate = dayjs().startOf("day");
  const previousMonthDate = currentDate.startOf("month");

  return {
    page: params?.page ?? 1,
    limit: params?.limit ?? 30,
    pm_adminids: params?.pm_adminids ?? [],
    inventory_type: params?.inventory_type ??
      InventoryTypeOptions.find((item) => item.id === "2") ?? {
        id: "-1",
        value: "Select",
      },
    order_id: params?.order_id ?? [],
    order_type: params?.order_type ?? [],
    customer_id: params?.customer_id ?? [],
    start_date: query_params.get("start_date")
      ? dayjs(query_params.get("start_date"), "YYYY-MM-DD")
      : previousMonthDate,
    end_date: query_params.get("end_date")
      ? dayjs(query_params.get("end_date"), "YYYY-MM-DD")
      : currentDate,
    sortBy: params?.sortBy || "created_date",
    sortType: params?.sortType ?? SortType.DESC,
  };
}
